<template>
    <div class="card-container">
        <common-top-form
            ref="commonTopForm"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            @openAddDialog="openAddDialog"
            :show="false"
            :selectShow="true"
            selectShowPower="/userluckdrawinfo/select"
            addShowPower="/userluckdrawinfo/add"
            :needCheck="needCheck"
            @check="handleTopCheck"
        >
            <el-form-item label="商户ID">
                <el-input
                    type="text"
                    maxlength="20"
                    v-model="formModel.merchantNo"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="商户手机号">
                <el-input
                    type="text"
                    maxlength="20"
                    v-model="formModel.merPhone"
                    placeholder="请输入手机号"
                ></el-input>
            </el-form-item>
            <el-form-item label="抽奖档期名称">
                <el-select v-model="formModel.pondId" clearable>
                    <el-option
                        v-for="item in movie"
                        :key="item.id"
                        :label="item.scheduleName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="轮盘类型">
                <el-select v-model="formModel.isReal" clearable>
                    <el-option
                        v-for="item in realType"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="scheduleName"
                label="抽奖档期名称"
                min-width="150"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merNo"
                label="商户ID"
                min-width="160"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merName"
                label="商户姓名"
                min-width="160"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merPhone"
                label="商户手机号"
                min-width="160"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="money"
                label="金额(元)"
                min-width="160"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="ifPrize"
                label="是否中奖"
                min-width="160"
                :formatter="formatterTableData"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <p>
                        {{
                        scope.row.ifPrize == 0
                        ? "是"
                        : scope.row.ifPrize == 1
                        ? "否"
                        : "--"
                        }}
                    </p>
                </template>
            </el-table-column>
            <el-table-column
                prop="isReal"
                label="轮盘类型"
                min-width="160"
                :formatter="formatterTableData"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <p>
                        {{
                        scope.row.isReal == 0
                        ? "假"
                        : scope.row.isReal == 1
                        ? "真"
                        : "--"
                        }}
                    </p>
                </template>
            </el-table-column>
            <el-table-column
                prop="createTime"
                label="创建时间"
                min-width="190"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <!-- <el-table-column label="操作" min-width="160">
              <template slot-scope="scope">
                <el-button type="text" @click="openAddDialog(scope.row)"
                  >修改
                </el-button>
                <el-button type="text" @click="handleDelete(scope.row.id)"
                  >删除
                </el-button>
              </template>
            </el-table-column> -->
        </common-table>
        <form-dialog
            ref="formDialog"
            :formDialogTitle="itemId ? '修改' : '添加'"
            :model="dialogModel"
            :submitData="dialogData"
            labelWidth="120px"
            :rules="dialogRules"
            :dialogService="dialogService"
            @close="dialogClose"
            @success="dialogSuccess"
            class="note"
        >
            <el-form-item label="抽奖档期名称" prop="pondId">
                <el-select v-model="dialogModel.pondId" clearable :disabled="this.show">
                    <el-option
                        v-for="item in movie"
                        :key="item.id"
                        :label="item.scheduleName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机号" prop="phoneNumber">
                <el-input
                    v-model="dialogModel.phoneNumber"
                    maxlength="20"
                    placeholder="请输入手机号"
                    :disabled="this.show"
                ></el-input>
            </el-form-item>
            <div class="flex-row vertical-center mem-name">
                <p style="margin-right: 10px; margin-left: 10px">姓名:</p>
                <p v-if="memName">
                    {{ memName }}
                </p>
            </div>
            <el-form-item
                clearable
                label="奖品名称"
                prop="pondCommodId"
                v-if="dialogModel.pondId !== ''"
            >
                <el-select v-model="dialogModel.pondCommodId">
                    <el-option
                        v-for="item in luckGoods"
                        :key="item.id"
                        :label="item.commodityName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import FormDialog from "../../dialog/FormDialog";
    import ShowInfoDialog from "../../dialog/ShowInfoDialog";
    import APPService from "service/APPService";
    import FinanceService from "service/FinanceService";

    import Regs from "common/conf/Regs";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "userluckdrawinfo",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
            ShowInfoDialog,
        },
        data() {
            return {
                // 标题
                show: false,
                prizeshow: false,
                itemId: "",
                formModel: {
                    merchantNo: "",
                    merPhone: "",
                    pondId: "",
                    time: "",
                    isReal: "",
                },
                tableData: [],
                // memName: {},
                movie: [],
                luckGoods: [],
                realType: [{
                    id: '',
                    name: '全部'
                },{
                    id: '1',
                    name: '真'
                },{
                    id: '0',
                    name: '假'
                },],
                submitService: APPService.userLucklist,
                page: {},
                isPage: false,
                memName: "", //用户名
                memId: "", //用户id
                dialogModel: {
                    pondId: "",
                    pondCommodId: "",
                    phoneNumber: "",
                },
                dialogRules: {
                    pondCommodId: [
                        {
                            required: true,
                            message: "请选择抽奖名称",
                            // validator: blurText,
                        },
                    ],
                    pondId: [
                        {
                            required: true,
                            message: "请选择档期名称",
                        },
                    ],
                    phoneNumber: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (!value) {
                                    callback(new Error("请输入手机号"));
                                } else if (!Regs.phone.test(value)) {
                                    callback(new Error("请输入正确的11位手机号码"));
                                } else {
                                    this.getRealNameByPhone(value, (res) => {
                                        if (res.respCode == "0000") {
                                            this.memName = res.contents.realName;
                                            this.memId = res.contents.id;
                                            return callback();
                                        } else {
                                            callback(new Error("查询不到此用户"));
                                            this.memName = "";
                                            this.memId = "";
                                        }
                                    });
                                }
                            },
                        },
                    ],
                },
                enableStatus: [
                    {
                        value: "",
                        label: "全部",
                    },
                    {
                        value: "0",
                        label: "禁用",
                    },
                    {
                        value: "1",
                        label: "启用",
                    },
                ],
                needCheck: true,
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
        },

        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == "") {
                    this.formModel.time = [];
                }
                this.params = {
                    merchantNo: this.formModel.merchantNo,
                    merPhone: this.formModel.merPhone,
                    pondId: this.formModel.pondId,
                    isReal: this.formModel.isReal,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length) {
                    this.params.startDate = this.formModel.time[0];
                    this.params.endDate = this.formModel.time[1];
                }
                return this.params;
            },
            dialogData() {
                const params = {
                    userId: this.memId,
                    pondCommodId: this.dialogModel.pondCommodId,
                };
                if (this.itemId) {
                    params.id = this.itemId;
                }
                return params;
            },
            dialogService() {
                return this.itemId ? APPService.userLuckedit : APPService.userLuckadd;
            },
            ...mapGetters(["serverType", "tatId", "userId"]),
        },
        watch: {
            "dialogModel.pondId"(val, oldVal) {
                if (val) {
                    this.getLuck(val);
                }
            },
        },
        methods: {
            load() {
                this.formModel = {
                    pondId: "",
                    time: "",
                };
                this.page = this.$refs.commonTable.page;
                this.getList();
                this.getMovie();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                    this.needCheck = true;
                });
            },
            // 添加/修改
            openAddDialog(item) {
                this.itemId = item ? item.id : "";
                if (this.itemId) {
                    this.dialogModel = JSON.parse(JSON.stringify(item));
                    this.memName = this.dialogModel.userName;
                    this.dialogModel.phoneNumber = this.dialogModel.phone;
                    this.show = true;
                }
                this.$refs.formDialog.open();
            },

            dialogSuccess(res) {
                this.commonSuccess(res);
                this.$refs.formDialog.closeDialog();
            },

            // 删除数据
            handleDelete(id) {
                this.showConfirm("确定删除该数据？")
                    .then(() => {
                        this.doDelete(id);
                    })
                    .catch(() => {
                    });
            },
            doDelete(id) {
                this.doLoad(
                    APPService.userLuckdel,
                    {
                        id: id,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.commonSuccess(res);
                        });
                    },
                    "操作失败"
                );
            },
            getMovie() {
                this.doLoad(
                    APPService.roulettelList,
                    "",
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.movie = [...res.contents.rows];
                        });
                    },
                    "信息获取失败"
                );
            },
            getLuck(val) {
                this.doLoad(
                    APPService.userLuck,
                    {
                        pondId: val,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.luckGoods = [...res.contents];
                        });
                    },
                    "信息获取失败"
                );
            },
            getRealNameByPhone(val, onSuccess) {
                const params = {
                    phone: val,
                };
                this.doLoad(
                    FinanceService.getRealNameByPhone,
                    params,
                    (res) => {
                        onSuccess && onSuccess(res);
                    },
                    "信息获取失败"
                );
            },
            // 弹框关闭清空数据
            dialogClose() {
                this.dialogModel = {
                    pondId: "",
                    pondCommodId: "",
                    phoneNumber: "",
                };
                this.memName = "";
                this.memId = "";
                this.show = false;
            },
            commonSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
            },
            handleTopCheck() {
                if (!this.formModel.pondId) {
                    this.showWarming("请输选择抽奖档期名称");
                    return;
                }
                this.needCheck = false;
                this.$refs.commonTopForm.submit();
            },
        },
    };
</script>
<style scoped>
    .mem-name p {
        margin-bottom: 20px;
        vertical-align: middle;
        line-height: 40px;
        color: rgba(170, 170, 170, 1);
    }

    .mem-name p:first-child {
        display: inline-block;
        width: 90px;
        text-align: right;
        vertical-align: middle;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/UserLuckdrawInfo.vue